export default Object.freeze({
  ReadOnly: 'readonly',
  Hidden: 'hidden',
  Visible: 'visible',
  Required: 'required',
  NotRequired: 'not-required',
  VisibleAndSkipFormulaEvaluation: 'visible-and-skip-formula-evaluation',
  HiddenAndSkipFormulaEvaluation: 'hidden-and-skip-formula-evaluation',
  Locked: 'locked',
});
